import { render, staticRenderFns } from "./BreakInfinityTab.vue?vue&type=template&id=7b13de95&scoped=true&"
import script from "./BreakInfinityTab.vue?vue&type=script&lang=js&"
export * from "./BreakInfinityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13de95",
  null
  
)

export default component.exports